<template>
                <div class="news-items mt54">
                    
                    <a href="/NewsDetail/109" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1700212954566255.png" alt="陈祥受邀出席四川省大熊猫国家公园文创产业年会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/09<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">陈祥受邀出席四川省大熊猫国家公园文创产业年会</div>
                                <div class="desc">近日，由四川省大熊猫国家公园文化创意创新联盟、成都大熊猫旅游文化产业促进会主办的四川省大熊猫国家公园文创产业年会在成都第十届创意设计周8号路演大厅顺利召开。融贯国际总经理陈祥先生受邀出席并发表致辞。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/HHImyDRtlxohF1rE0DCskw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1700213345780629.png" alt="冯文滔受邀出席2023国际金融科技论坛" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">11/07<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">冯文滔受邀出席2023国际金融科技论坛</div>
                                <div class="desc">2023年11月7日，2023国际金融科技论坛暨友仑集团第七届金融科技创新论坛在香港数码港举行，融贯国际董事长冯文滔先生受邀出席并参与“金融科技发展浪潮，推动数字化资产创新发展”圆桌讨论。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/vUzOeeGzl35pg5XiTrSymw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1700213565831671.jpg" alt="展会回顾 | 澳优码呈现数字赋能新风采" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/24<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">展会回顾 | 澳优码呈现数字赋能新风采</div>
                                <div class="desc">2023年10月19-22日，第二十八届澳门国际贸易投资展览会（简称第28届MIF）在澳门隆重举行。为进一步深化展示澳优码（MID）服务平台亮眼成果，澳门质量品牌国际认证联盟与融贯国际携澳优码最新溯源成果亮相。本次参展设置三个专区展位，分别为澳优码然选优品馆、四商会澳门国际经贸馆、MFE澳门国际品牌连锁加盟展位。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/4GYVHPT0KLCf1M_KTdZ_sA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1697989788458930.jpg" alt="第28届MIF | 融贯国际精彩展示多元化数字领域创新成果" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/22<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">第28届MIF | 融贯国际精彩展示多元化数字领域创新成果</div>
                                <div class="desc">澳门质量品牌国际认证联盟携手融贯国际、浪潮云洲集团等公司在本届MIF设立了中葡数字贸易馆与澳优码然选优品馆，同期牵头政企力量承办多场学术与文化交流活动，数字领域创新应用与交流成果瞩目。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/Zr2bJuzJKnkCMfSLPsQmug" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1697989650790347.png" alt="融贯国际与亳州文旅集团“牵手”前行" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/22<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">融贯国际与亳州文旅集团“牵手”前行</div>
                                <div class="desc">10月21日上午，参加第二十八届澳门国际贸易投资展览会的亳州代表团到澳门融贯投资科技有限公司进行座谈交流。会上，亳州文旅集团与澳门融贯投资科技有限公司签订战略合作协议，集团党委书记、董事长雅浩海和澳门融贯投资科技有限公司总经理陈祥分别代表双方签约。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/vSSjoMvPdvjR7iCPLq5pLA" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1697989600805871.jpg" alt="2023盛世数藏-非遗藏品数字展拍会圆满收官！" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/22<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">2023盛世数藏-非遗藏品数字展拍会圆满收官！</div>
                                <div class="desc">2023年10月19日18时整，由澳门质量品牌国际认证联盟主办，融贯国际、一白艺术有限公司及澳门宝顺拍卖联合呈现的“2023盛世数藏-非遗藏品数字展拍会”在澳门美高梅宴会厅正式启动并于当晚圆满收官。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/YBqmjyfmhrYLykhkQ_tg0g" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1699599724137169.jpg" alt="「湾区认证」港澳地区首次亮相" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/22<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">「湾区认证」港澳地区首次亮相</div>
                                <div class="desc">10月22日 澳门特别行政区｜第28届澳门国际贸易投资展览会（MIF） 成功召开由广东粤港澳大湾区认证促进中心与澳门质量品牌国际认证联盟共同主办“湾区品质 服务全球”——湾区认证助力区域贸易便利化发展论坛。本次论坛活动是「湾区认证」面向葡语系国家的重要展示推广，是“湾区认证”首次在港澳地区亮相。</div>
                            </div>
                        </div>
                    </a>
                    
                    <a href="https://mp.weixin.qq.com/s/jMMXoOFR1bPzqQrZaSDBDw" class="items wow com-animate-f" ondragstart="return false" style="visibility: visible;">
                        <div class="pic"><img src="@/assets/images/1697989411864240.jpg" alt="加快推动数实融合 融贯国际举办第一届国际国际数字社区+生态发展大会" class="img-wrap" ondragstart="return false"></div>
                        <div class="rgt">
                            <div class="time"><div class="in">10/21<span>2023</span></div></div>
                            <div class="info">
                                <div class="title">加快推动数实融合 融贯国际举办第一届国际国际数字社区+生态发展大会</div>
                                <div class="desc">澳区省级政协委员联谊会、澳门质量品牌国际认证联盟主办，融贯国际承办的“2023第一届国际数字社区+生态发展大会”，10月21日于威尼斯人西西里厅举行。</div>
                            </div>
                        </div>
                    </a>
                    
                   
                </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .news-container {
    padding-top: 84px;
 }

 .news-banner {
    position: relative;
 }
 .news-banner .banner {
    width: 100%;
 }
 .news-banner .banner img {
    width: 100%;
    object-fit: cover;
 }
 .news-banner .banner-desc {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;
    color: #FFFFFF;
 }
 .banner-desc-text {
    margin: auto;
    width: 80%;
    max-width: 1200px;
    margin: auto;
 }
 .news-banner .banner-desc .title {
    font-size: 30px;
 }
 .news-banner .banner-desc .text {
    margin-top: 14px;
    font-size: 15px;
    line-height: 24px;
    opacity: .8;
    max-width: 500px;
 }
 .news-banner .title-en {
    font-size: 18px;
    margin-top: 8px;
    text-transform: uppercase;
    font-weight: bold;
    color: #e5e5e5;
    font-family: OPPOSans-H;
}

.news-list {
    background: #fafafa;
    padding: 80px 0;
}
.contain {
    width: 1200px;
    margin: 0 auto;
}


.news-items .items {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 20px 19px;
    transition: box-shadow .4s ease;
    border-radius: 4px;
}
.news-items .items:hover {
    box-shadow: 0px 11px 9px 0px rgba(28, 72, 146, 0.1);
}
.news-items .items:not(:first-child) {
    margin-top: 35px;
}

.news-items .items .pic {
    position: relative;
    padding-top: 18.209%;
    width: 29.663%;
    overflow: hidden;
    border-radius: 4px;
}
.img-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;
    object-fit: cover;
}
.news-items .items .rgt {
    flex: 1;
    display: flex;
    align-items: center;
}
.news-items .items .time {
    width: 18%;
    display: flex;
    justify-content: center;
    color: #000000;
    line-height: 1;
    font-weight: bold;
    font-family: OPPOSans-H;
    font-size: 18px;
}
.news-items .items .time span {
    display: block;
    color: #9f9e9e;
    font-size: 16px;
    font-weight: normal;
    margin-top: 10px;
}
    .news-items .items .info {
        flex: 1;
        font-size: 16px;
        line-height: 24px;
        padding-right: 20px;
    }
    .news-items .items .info .title {
        font-weight: 500;
        color: #444444;
        transition: color .4s ease;
    }
    .news-items .items:hover .info .title {
        color: #e75416;
    }
    .news-items .items .info .desc {
        margin-top: 10px;
        color: #777777;
    }

  </style>